import { createFileRoute, redirect } from '@tanstack/react-router'
import { LotDetailScreen } from '@/features/inventory-lots/lot-detail-screen'
import { hasGrant } from '@/lib/me'

export const Route = createFileRoute('/_authenticated/inventory/lots/$lotId')({
  beforeLoad: ({ context }) => {
    if (!hasGrant(context.queryClient, 'lot.view')) throw redirect({ to: '/' })
  },
  component: LotDetailRoute,
})

function LotDetailRoute() {
  const { lotId } = Route.useParams()

  return <LotDetailScreen lotId={lotId} />
}
